"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FormGrid = (0, _styledComponents.default)(_semanticUiReact.Form)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n    padding: 0 !important;\n  }\n\n  & div:first-child {\n    width: 50%;\n    margin: 0 !important;\n  }\n\n  & div:first-child > div.field {\n    width: 100%;\n  }\n"])));

var DependencyBuilder = function DependencyBuilder(_ref) {
  var store = _ref.store,
      schema = _ref.schema,
      readOnly = _ref.readOnly;

  var handleRemoveDependency = function handleRemoveDependency(dependency) {
    store.removeDependency(dependency.id);
  };

  var handleEditDependencyName = function handleEditDependencyName(e, dependency) {
    store.editDependencyName(dependency.id, e.target.value);
  };

  var handleEditDependencyField = function handleEditDependencyField(dependency, value) {
    store.editDependencyField(dependency.id, value);
  };
  /* const handleEditDependencyTrigger = (dependency, isChecked) => {
    store.editDependencyTrigger(dependency.id, isChecked);
  }; */


  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      minHeight: 83
    }
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
    padded: true,
    columns: "equal"
  }, store.dependencies.map(function (dependency) {
    return !readOnly ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, {
      key: dependency.id,
      verticalAlign: "middle"
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
      tablet: 16,
      computer: 7
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement("label", null, "Nombre"), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Input, {
      placeholder: "Nombre de la dependencia",
      onChange: function onChange(e) {
        handleEditDependencyName(e, dependency);
      },
      onBlur: function onBlur(e) {
        handleEditDependencyName(e, dependency);
      },
      size: "tiny",
      type: "text",
      value: dependency.name
    }))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
      tablet: 16,
      computer: 7
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement("label", null, "Campo"), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
      selection: true,
      options: schema,
      value: dependency.field,
      selectOnNavigation: false,
      onChange: function onChange(evt, target) {
        handleEditDependencyField(dependency, target.value);
      }
    }))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
      tablet: 8,
      computer: 2,
      textAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
      icon: true,
      onClick: function onClick() {
        handleRemoveDependency(dependency);
      }
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
      name: "remove circle",
      size: "large"
    })))) : /*#__PURE__*/_react.default.createElement(FormGrid, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Input, {
      readOnly: true,
      size: "tiny",
      type: "text",
      value: dependency.name
    })), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
      icon: true,
      onClick: function onClick() {
        handleRemoveDependency(dependency);
      }
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
      name: "remove circle"
    }))));
  }))));
};

var _default = DependencyBuilder;
exports.default = _default;